const fr = {
  nav: {
    overview: 'Aperçu', inventory: 'Inventaire', crm: 'CRM', wholesale: 'Gros',
    analytics: 'Analyses', vinDecoder: 'Décodeur VIN', profitCalc: 'Calc. Profit',
    aiTools: 'Outils IA', leadNetwork: 'Réseau Leads', salesInvoices: 'Ventes/Factures',
    expenses: 'Dépenses', repairs: 'Réparations', docCenter: 'Centre Docs', imagePro: 'Image Pro',
    importExport: 'Import/Export', settings: 'Paramètres', signOut: 'Déconnexion',
  },
  landing: {
    hero: "L'Avenir de la Technologie Automobile",
    heroSub: 'Plateforme complète de gestion — inventaire, CRM, outils IA et rapports d\'historique de véhicule en un seul endroit.',
    getStarted: 'Commencer Gratuitement',
    viewPricing: 'Voir les Tarifs',
    features: 'Fonctionnalités',
    pricing: 'Tarifs',
    pricingTitle: 'Tarifs Simples et Transparents',
    pricingSub: "Essai gratuit de 7 jours. Aucune carte de crédit requise.",
    perMonth: '/mois',
    subscribe: 'Commencer',
    currentPlan: 'Plan Actuel',
    featuresTitle: 'Tout ce dont Vous Avez Besoin',
    featuresSub: 'Conçu pour les concessionnaires modernes qui veulent réussir.',
    trustedBy: 'Approuvé par plus de 500 concessionnaires',
  },
  auth: {
    login: 'Se Connecter',
    register: 'Créer un Compte',
    email: 'E-mail',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le Mot de passe',
    name: 'Nom Complet',
    companyName: 'Nom de l\'Entreprise / Concession',
    phone: 'Numéro de Téléphone',
    forgotPassword: 'Mot de passe oublié ?',
    noAccount: "Vous n'avez pas de compte ?",
    hasAccount: 'Vous avez déjà un compte ?',
    signUp: "S'inscrire",
    signIn: 'Se Connecter',
    resetPassword: 'Réinitialiser le Mot de passe',
    sendResetLink: 'Envoyer le Lien',
    backToLogin: 'Retour à la Connexion',
    loggingIn: 'Connexion en cours...',
    creating: 'Création du compte...',
    startTrial: 'Commencez votre essai gratuit de 7 jours',
    resetSub: 'Entrez votre e-mail et nous vous enverrons un lien de réinitialisation.',
  },
  dashboard: {
    title: 'Tableau de Bord',
    totalVehicles: 'Total Véhicules',
    available: 'Disponibles',
    inventoryValue: "Valeur de l'Inventaire",
    conversionRate: 'Taux de Conversion',
    searchVehicles: 'Rechercher des véhicules...',
    addVehicle: 'Ajouter un Véhicule',
    noVehicles: 'Aucun véhicule trouvé',
  },
  vin: {
    title: 'Décodeur VIN',
    subtitle: 'Entrez un VIN de 17 caractères pour décoder',
    decode: 'Décoder',
    enterVin: 'Entrez un VIN de 17 caractères',
    wakzyCheck: 'Wakzy Check',
    wakzyCheckSub: "Rapport Premium d'Historique Véhicule — données NHTSA",
    runReport: 'Générer le Rapport',
    generating: 'Génération du Rapport Wakzy Check...',
    generatingSub: 'Vérification des rappels, cotes de sécurité, plaintes et plus',
    wakzyScore: 'Score Wakzy',
    noAccidents: 'Aucun Accident',
    cleanTitle: 'Titre Propre',
    recalls: 'Rappels',
    owners: 'Propriétaires',
    personalUse: 'Usage Personnel',
    safetyRating: 'Cote de Sécurité',
    marketValue: 'Valeur Marchande Est.',
    expectedMileage: 'Kilométrage Attendu',
    ownership: 'Propriété',
    estOwners: 'Propriétaires Est.',
    usage: 'Usage',
    vehicleAge: 'Âge du Véhicule',
    years: 'ans',
    scoreBreakdown: 'Détail du Score Wakzy',
    safetySpecs: 'Sécurité et Spécifications',
    timeline: 'Chronologie',
    complaints: 'Plaintes',
    safetyRatings: 'Cotes de Sécurité',
    safetyEquipment: 'Équipement de Sécurité',
    vehicleSpecs: 'Spécifications du Véhicule',
    vehicleTimeline: "Chronologie de l'Historique",
    cleanHistory: 'Historique Propre',
    noEvents: 'Aucun événement significatif trouvé',
    safetyRecalls: 'Rappels de Sécurité',
    noRecalls: 'Aucun Rappel Trouvé',
    consumerComplaints: 'Plaintes des Consommateurs',
    noComplaints: 'Aucune Plainte Trouvée',
    risk: 'Risque',
    fix: 'Correction',
    crashes: 'Accidents',
    fires: 'Incendies',
    injuries: 'Blessures',
    print: 'Imprimer',
    overall: 'Global',
    frontalCrash: 'Choc Frontal',
    sideCrash: 'Choc Latéral',
    rollover: 'Retournement',
    notRated: 'Non Évalué',
    bodyType: 'Type de Carrosserie', engine: 'Moteur', horsepower: 'Puissance',
    transmission: 'Transmission', driveType: 'Traction', fuelType: 'Type de Carburant',
    vehicleType: 'Type de Véhicule', doors: 'Portes', trim: 'Finition', country: 'Pays',
  },
  docs: {
    title: 'Centre de Documents',
    subtitle: 'Générez, gérez et numérisez les documents du concessionnaire',
    library: 'Bibliothèque', generate: 'Générer', templates: 'Modèles',
    signatures: 'Signatures', aiScanner: 'Scanner IA',
    upload: 'Téléverser', auditLog: "Journal d'Audit",
    total: 'Total', pending: 'En Attente', expiring: 'Bientôt Expiré',
    expired: 'Expiré', missing: 'Manquant',
    missingDocs: 'Documents Manquants',
    searchDocs: 'Rechercher VIN, stock #, client, fichier...',
    allTypes: 'Tous les Types', allStatus: 'Tous les Statuts',
    active: 'Actif', archived: 'Archivé',
    document: 'Document', type: 'Type', vinStock: 'VIN / Stock #',
    customer: 'Client', status: 'Statut', date: 'Date', actions: 'Actions',
    noDocs: 'Aucun document trouvé',
    uploadFirst: 'Téléversez ou générez votre premier document',
    generateDoc: 'Générer le Document',
    generateClosing: 'Générer le Dossier de Clôture',
    closingDesc: "Acte de Vente + Déclaration d'Odomètre + Bon de Commande — tout en une impression",
    template: 'Modèle', vehicle: 'Véhicule', selectVehicle: 'Sélectionner un véhicule...',
    selectCustomer: 'Sélectionner un client...',
    salePrice: 'Prix de Vente', dealerFee: 'Frais du Concessionnaire', salesTax: 'Taxe de Vente',
    totalAmount: 'Total', paymentMethod: 'Mode de Paiement', dateOfSale: 'Date de Vente',
    printSavePdf: 'Imprimer / Enregistrer PDF',
    selectTemplate: 'Sélectionnez un modèle et générez',
    autoFill: 'Les documents se remplissent automatiquement avec les données du véhicule et du client',
    customTemplates: 'Modèles Personnalisés', newTemplate: 'Nouveau Modèle',
    noTemplates: "Aucun modèle personnalisé pour l'instant",
    createTemplates: 'Créez des modèles de documents réutilisables pour votre concession',
    saveTemplate: 'Enregistrer le Modèle', updateTemplate: 'Mettre à Jour le Modèle',
    addSection: 'Ajouter une Section', addField: 'Ajouter un Champ',
    templateName: 'Nom', accentColor: "Couleur d'Accent", description: 'Description',
    autoFillPlaceholders: 'Marqueurs de Remplissage Auto',
    digitalSignatures: 'Signatures Numériques',
    signaturesSub: 'Signez les documents numériquement — sauvegardées pour réutilisation',
    createSignature: 'Créer une Nouvelle Signature',
    savedSignatures: 'Signatures Sauvegardées',
    noSignatures: 'Aucune signature sauvegardée',
    scanDocument: 'Numériser un Document',
    scanSub: "Téléversez une image du document — l'IA extrait VIN, client et montants",
    enterpriseFeature: 'Fonctionnalité du Plan Enterprise',
    extractedData: 'Données Extraites',
    scanResults: 'Les résultats du scan apparaîtront ici',
    applyToUpload: 'Appliquer au Formulaire de Téléversement',
    uploadDocument: 'Téléverser un Document',
    chooseFile: 'Choisir un Fichier',
    uploading: 'Téléversement...',
  },
  imagePro: {
    title: 'Dealer Image Pro',
    subtitle: "Suite de Photographie Automobile par l'IA",
    dropOrClick: 'Glissez une image ou cliquez pour téléverser',
    allFormats: 'Supporte TOUS les formats — JPEG, PNG, WebP, HEIC, TIFF, BMP, AVIF',
    autoConvert: 'Les formats non standard sont convertis automatiquement en JPEG',
    download: 'Télécharger', share: 'Partager', saveToLibrary: 'Enregistrer dans la Bibliothèque',
    bgPresets: 'Arrière-plans Prédéfinis', customBg: 'Arrière-plan Personnalisé',
    uploadBgImage: "Téléverser une Image d'Arrière-plan",
    replaceBg: "Remplacer l'Arrière-plan", processing: 'Traitement...',
    copyCaption: 'Copier la Description', websiteEmbed: 'Code pour Site Web',
    sharePost: 'Partager et Publier',
  },
  crm: {
    contacts: 'Contacts', addContact: 'Ajouter un Contact', searchContacts: 'Rechercher des contacts...',
    name: 'Nom', email: 'E-mail', phone: 'Téléphone', stage: 'Étape', source: 'Source',
    lastInteraction: 'Dernière Interaction', noContacts: 'Aucun contact trouvé',
  },
  common: {
    save: 'Enregistrer', cancel: 'Annuler', delete: 'Supprimer', edit: 'Modifier', close: 'Fermer',
    confirm: 'Confirmer', search: 'Rechercher', filter: 'Filtrer', loading: 'Chargement...',
    noData: 'Aucune donnée', error: 'Erreur', success: 'Succès', back: 'Retour',
    next: 'Suivant', previous: 'Précédent', submit: 'Soumettre', clear: 'Effacer',
    selectAll: 'Tout Sélectionner', selected: 'sélectionnés', download: 'Télécharger',
    yes: 'Oui', no: 'Non', or: 'OU', and: 'et',
    language: 'Langue',
  },
  admin: {
    overview: 'Aperçu', users: 'Utilisateurs', idVerification: "Vérification d'ID",
    vehicles: 'Véhicules', revenue: 'Revenus', moderation: 'Modération',
    announcements: 'Annonces', emailDigest: "Résumé d'E-mails",
    activityLog: "Journal d'Activité", systemHealth: 'État du Système',
    platformSettings: 'Config. Plateforme', notifications: 'Notifications',
    signOut: 'Déconnexion', totalUsers: 'Total Utilisateurs', junkLeads: 'Leads Épaves',
    estMrr: 'MRR Estimé', thisWeek: 'cette semaine', available: 'disponibles',
    active: 'actifs', subscribers: 'abonnés', searchCmd: 'Rechercher...',
  },
};

export default fr;
